import React, { memo } from 'react';
import { Typography } from '../../../foundations/typography';
import styles from './EntertainingAttributes.module.scss';
export var EntertainingAttributes = memo(function (_a) {
    var attributes = _a.attributes;
    if (Object.keys(attributes).length < 1)
        return null;
    return (React.createElement("ul", { "aria-label": "product attributes", className: styles.entertainingAttributes, role: "group" }, Object.entries(attributes).map(function (_a) {
        var type = _a[0], label = _a[1];
        return (React.createElement(Typography, { element: "li", noMargins: true, "data-type": type, role: "presentation", key: "".concat(type, "-").concat(label) }, label));
    })));
});
//# sourceMappingURL=EntertainingAttributes.js.map